import { MetadataType } from '@aibees/elephant/hooks';
import { capitalize } from '@aibees/shared/utils';
import { FilterCategory, SearchFilterBase, SearchFilterType } from '../types';

export default function annualRevenueFilterConfig(): SearchFilterBase {
  return {
    name: 'Annual Revenue',
    icon: 'dollar-outline',
    index: 3,
    type: SearchFilterType.ROOT,
    category: [FilterCategory.COMPANY_DATA],
    pinned: true,
    items: [
      {
        name: '',
        type: SearchFilterType.RADIO_GROUP,
        icon: undefined,
        index: 0,
        key: undefined,
        field: undefined,
        metadata: {},
        utils: {
          tags: {
            config: {
              showAsCard: true,
              tagsCardTitle: 'Annual Revenue',
            },
          },
        },
        config: { labelKey: 'label', valueKey: 'value' },
        sections: { main: 1, more: 1 },
        items: [
          {
            name: 'Predefined Range',
            type: SearchFilterType.CHECK_BOX,
            icon: undefined,
            index: 0,
            layer: 4,
            key: 'revenue',
            field: 'revenue',
            metadata: {
              color: 'primary',
              metaDataApi: {
                enabled: true,
                key: MetadataType.COMPANY_REVENUE,
              },
            },
            config: { labelKey: 'label', valueKey: 'value' },
            options: [],
            nested: true,
            open: true,
          },
          {
            name: 'Annual Revenue N/A',
            type: SearchFilterType.NOT_AVAILABLE,
            icon: undefined,
            index: 0,
            layer: 4,
            key: 'annual_revenue_availability',
            field: 'annual_revenue_availability',
            metadata: {
              labelColor: 'primary',
              color: 'primary',
            },
            nested: true,
            utils: {
              tags: {
                labelFormatter: (value: string) =>
                  capitalize(value.replace('_', ' ')),
              },
            },
          },
        ],
      },
    ],
  };
}
